import Vue from 'vue'
import moment from 'moment'

Vue.filter('calendar', function (value) {
  if (value) {
    return moment.unix(value).format('MMMM Do YYYY, h:mm a')
  } else {
    return ''
  }
})
Vue.filter('calendarNoTime', function (value) {
  if (value) {
    return moment.unix(value).format('MMMM Do YYYY')
  } else {
    return ''
  }
})
Vue.filter('calendarShort', function (value) {
  if (value) {
    return moment(value).format('Do MMM YYYY')
  } else {
    return ''
  }
})
Vue.filter('calendarUnix', function (value) {
  if (value) {
    return moment.unix(value).format('Do MMM YYYY')
  } else {
    return ''
  }
})
Vue.filter('calendarShorter', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YY')
  } else {
    return ''
  }
})
Vue.filter('calendarShortUnix', function (value) {
  if (value) {
    return moment.unix(value).format('DD/MM/YYYY')
  } else {
    return ''
  }
})
Vue.filter('format_day', function (value) {
  return moment(value).format('ddd') + '\n' + value.format('DD')
})
Vue.filter('parse_day', function (value) {
  if (value) {
    var date = moment.unix(value)
    return moment(date).format('dddd')
  } else {
    return '--'
  }
})
Vue.filter('format_ISO', function (value) {
  if (value) {
    var date = moment.unix(value)
    return moment(date).format('dddd')
  } else {
    return '--'
  }
})
Vue.filter('uppercase', function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('ifNull', function (value) {
  if (!value) {
    return '--'
  } else {
    return value
  }
})
Vue.filter('two_digits', function (value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString()
  }
  return value
})
Vue.filter('weight', function (value) {
  var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
  return value + ' ' + localMeasureSystem.weight
})
Vue.filter('progress', function (value) {
  if (!value) {
    return 0
  } else {
    var start = moment.unix(value)
    var today = moment()
    var diff = today.diff(start, 'days')
    return Math.floor((diff / 84) * 100)
  }
})
Vue.filter('progressWeek', function (value) {
  if (!value) {
    return 0
  } else {
    var currentDay = moment().dayOfYear()
    var startingDay = moment.unix(value).dayOfYear()
    var diff = currentDay - startingDay
    var diffWeeksRounded = Math.trunc(diff / 7)
    return diffWeeksRounded + 1
  }
})
Vue.filter('totalKcals', function (value) {
  if (value) {
    return Math.floor(value * 4)
  } else {
    return null
  }
})
Vue.filter('milestone', function (value) {
  if (value) {
    switch (value) {
      case 1:
        return 'Starting'
      case 2:
        return 'Phase 1'
      case 3:
        return 'Phase 2'
      case 4:
        return 'Graduation'
      default:
        return 'No Set'
    }
  }
})
Vue.filter('diplayWeek', function (value) {
  if (value) {
    switch (value) {
      case 1:
        return 1
      case 2:
        return 4
      case 3:
        return 8
      case 4:
        return 2
      default:
        return '--'
    }
  }
})
Vue.filter('weekOfYear', function (value) {
  var week = parseInt(value, 10)
  var current = moment().week()
  if (value) {
    if (week === current) {
      return 'This Week'
    } else if (week === current - 1) {
      return 'Last Week'
    } else {
      return moment().week(week).startOf('week').format('D') + ' - ' + moment().week(week).endOf('week').format('D MMM YYYY')
    }
  }
})
Vue.filter('firstWord', function (value) {
  if (value) {
    return value.substr(0, value.indexOf(' '))
  }
})
Vue.filter('striphtml', function (value) {
  if (value) {
    var div = document.createElement('div')
    div.innerHTML = value
    var text = div.textContent || div.innerText || ''
    return text
  } else {
    return null
  }
})
Vue.filter('displayWeight', function (value) {
  function kgToLbs (kgs) {
    var lbs = (kgs * 2.205)
    var decimal = +lbs
    return decimal.toFixed(2)
  }
  if (value) {
    var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
    if (localMeasureSystem.weight === 'lbs') {
      return kgToLbs(value)
    } else {
      var n = value
      if (Number.isInteger(n)) {
        return value
      } else {
        return +n.toFixed(2)
      }
    }
  } else {
    return '--'
  }
})
Vue.filter('toLbs', function (value) {
  function lbsToKgs (kgs) {
    var lbs = (kgs * 2.205)
    var decimal = +lbs
    return Math.round(decimal)
  }
  if (value) {
    var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
    if (localMeasureSystem.weight === 'lbs') {
      return lbsToKgs(value)
    } else {
      return value
    }
  } else {
    return ''
  }
})
Vue.filter('toLbsDecimal', function (value) {
  function lbsToKgs (kgs) {
    var lbs = (kgs * 2.205)
    var decimal = +lbs
    return Math.round(decimal)
  }
  if (value) {
    var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
    if (localMeasureSystem.weight === 'lbs') {
      return lbsToKgs(value)
    } else {
      return value
    }
  } else {
    return '--'
  }
})
Vue.filter('toInches', function (value) {
  function cmsToInches (cms) {
    var inches = (cms / 2.54)
    return Math.round(inches)
  }
  if (value) {
    var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
    if (localMeasureSystem.length === 'inches') {
      return cmsToInches(value)
    } else {
      return value
    }
  } else {
    return '--'
  }
})
Vue.filter('length', function (value) {
  var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
  return value + ' ' + localMeasureSystem.length
})
Vue.filter('round', function (value) {
  if (value) {
    return Math.round(value)
  }
})
Vue.filter('roundToTwoDecimals', function (value) {
  if (value) {
    return Math.round(value * 100) / 100
  }
})



// WEBPACK FOOTER //
// ./src/services/filters.js